define('formkit/behavior/answer.value.failed.validations.behavior',['require','exports','module','marionette','underscore'],function(require, exports, module) {
  var Mn = require('marionette');
  var _  = require('underscore');

  var AnswerValueFailedValidationsBehavior = Mn.Behavior.extend({

    defaults: {
      templateObjectModel: null,
      formObjectState: null,
      form: null,
      previewAnswerView: null,
      onFailedVisibleValidations: null,
      onFailedValidations: null
    },

    onFirstRender: function() {
      var formObjectState = this.getOption('formObjectState');

      if (!this.getAnswerValueModel()) { return; }

      this.listenTo(formObjectState, 'failedValidations', function(formObjectState, failedValidations, options) {
        // note: need to get fresh answer value model each time because table answer value ids change
        var answerValueModel  = this.getAnswerValueModel();
        var failedVisibleValidations = _.filter(_.result(options, 'failedVisibleValidations'), function(failedValidation) {
          return failedValidation.answerValueId == answerValueModel.id;
        });
        if (_.isFunction(this.getOption('onFailedVisibleValidations'))) {
          this.getOption('onFailedVisibleValidations').call(this, failedVisibleValidations);
        }
        var failedValidations = _.filter(failedValidations, function(failedValidation) {
          return failedValidation.answerValueId == answerValueModel.id;
        });
        if (_.isFunction(this.getOption('onFailedValidations'))) {
          this.getOption('onFailedValidations').call(this, failedValidations);
        }
      });
    },

    getAnswerValueModel: function() {
      var previewAnswerView = this.getPreviewView();
      if (previewAnswerView.getAndLinkAnswerValueModel) {
        return previewAnswerView.getAndLinkAnswerValueModel(this.getOption('templateObjectModel'), this.getOption('form'));
      }
    },

    getPreviewView: function() {
      return Mn._getValue(this.getOption('previewAnswerView'), this) || this.view;
    }

  });

  module.exports = AnswerValueFailedValidationsBehavior;
});

